import script from "./Tests.vue?vue&type=script&setup=true&lang=js"
export * from "./Tests.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__